import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import i18next from 'i18next';
import MainTemplate from "../mainTemplate";
import ManualProvider from "../../shared/provider/manualProvider";
import FileProviderBSC from "./providers/fileProviderBSC";
import SearchProvider from "./providers/search";

import contactProvider from "../../../../static/images/contactProvider.svg";
import addManual from "../../../../static/images/add-file.svg";
import addFile from "../../../../static/images/file-add.svg";
import IDa from "../../../../static/images/id.svg";

import * as ClientActions from "../../../Redux/actions/clientActions";
import { loadingHtml, errorContainer } from "../../utils/functions";
import CustomModal from "../../utils/customModal";

const NewBackOfficeProvider = () => {
  const [state, setState] = useState({
    manualProvider: true,
    firstLoad: true,
    fileProviderBSC: false,
    bySearch: false,
  });

  const [modal, setModal] = useState({
    show: false,
    content: null,
  });

  const dispatch = useDispatch();

  const getProviderByCif = async (cif, country) => {
    setModal({ show: true, content: loadingHtml() });

    try {
      await dispatch(ClientActions.getClientByCif(cif, country));
      setState({
        manualProvider: true,
        firstLoad: false,
        fileProviderBSC: false,
        bySearch: true,
      });

      setModal({ show: false, content: null });
    } catch (err) {
      const title =
        err.response.status === 404 ? "Proveedor no encontrado" : "Error";

      setModal({
        show: true,
        content: errorContainer(
          title,
          err.response.data.notifications[0].message
        ),
      });
    }
  };

  const closeModal = () => setModal({ show: false, content: null });

  useEffect(() => {
    return () =>
      setState((prev) => ({
        ...prev,
        manualProvider: false,
        firstLoad: false,
      }));
  }, []);

  const onClickNew = () => {
    setState({
      manualProvider: true,
      firstLoad: false,
      fileProviderBSC: false,
      bySearch: false,
    });
  };

  return (
    <MainTemplate>
      <div className="container-add">
        <div className="row">
          <div className="col-4">
            <div className="actions-title">
              <img src={contactProvider} className="icon" />
              <p>{i18next.t('clients.providers.form.title')}</p>
            </div>
            <div className="btn-actions manual-load" onClick={onClickNew}>
              <img src={addManual} className="img" />
              <p>{i18next.t('clients.providers.form.manual')}</p>
            </div>
            <div
              className="btn-actions file-load"
              onClick={() =>
                setState((prev) => ({
                  ...prev,
                  manualProvider: false,
                  firstLoad: false,
                  fileProviderBSC: true,
                }))
              }
            >
              <img src={addFile} className="img" />
              <p>{i18next.t('clients.providers.form.upload_file')}</p>
            </div>
            <div
              className="btn-actions file-load1"
              onClick={() =>
                setState((prev) => ({
                  ...prev,
                  manualProvider: false,
                  firstLoad: false,
                  fileProviderBSC: false,
                }))
              }
            >
              <img src={IDa} className="img" />
              <p>{i18next.t('clients.providers.form.identification')}</p>
            </div>
          </div>
          <div className="col-8">
            {!state.firstLoad ? (
              state.manualProvider ? (
                <ManualProvider
                  bySearch={state.bySearch}
                  bscForm={true}
                  submitUrl={`/providers`}
                />
              ) : state.fileProviderBSC ? (
                <FileProviderBSC />
              ) : (
                <SearchProvider getProviderByCif={getProviderByCif} />
              )
            ) : null}
          </div>
        </div>
        <CustomModal
          key={`table-modal`}
          show={modal.show}
          handleClose={closeModal}
        >
          {modal.content}
        </CustomModal>
      </div>
    </MainTemplate>
  );
};

export default NewBackOfficeProvider;

/* 
export class NewBackOfficeProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      manualProvider: true,
      firstLoad: true,
      fileProviderBSC: false,
      bySearch: false,
      modal: {
        show: false,
        content: null,
      },
    };
  }

  getProviderByCif = (cif, country) => {
    const {
      actions: { getClientByCif },
    } = this.props;

    this.setState({ modal: { show: true, content: loadingHtml() } });

    return getClientByCif(cif, country)
      .then(() => {
        this.setState({
          manualProvider: true,
          firstLoad: false,
          fileProviderBSC: false,
          bySearch: true,
          modal: { show: false, content: null },
        });
      })
      .catch((err) => {
        var title = "Error";
        switch (err.response.status) {
          case 404:
            title = "Proveedor no encontrado";
            break;
        }

        this.setState({
          modal: {
            show: true,
            content: errorContainer(
              title,
              err.response.data.notifications[0].message
            ),
          },
        });
      });
  };

  closeModal = () => {
    this.setState({ modal: { show: false, content: null } });
  };

  componentWillUnmount() {
    this.setState({ manualProvider: false, firstLoad: false });
  }

  render() {
    const { modal } = this.state;

    return (
      <MainTemplate>
        <div className="container-add">
          <div className="row">
            <div className="col-4">
              <div className="actions-title">
                <img src={`/static/${contactProvider}`} className="icon" />
                <p>AGREGAR NUEVO PROVEEDOR</p>
              </div>
              <div
                className="btn-actions manual-load"
                onClick={() =>
                  this.setState({
                    manualProvider: true,
                    firstLoad: false,
                    fileProviderBSC: false,
                    bySearch: false,
                  })
                }
              >
                <img src={`/static/${addManual}`} className="img" />
                <p>Agregar manual</p>
              </div>
              <div
                className="btn-actions file-load"
                onClick={() =>
                  this.setState({
                    manualProvider: false,
                    firstLoad: false,
                    fileProviderBSC: true,
                  })
                }
              >
                <img src={`/static/${addFile}`} className="img" />
                <p>Subir un archivo</p>
              </div>
              <div
                className="btn-actions file-load1"
                onClick={() =>
                  this.setState({
                    manualProvider: false,
                    firstLoad: false,
                    fileProviderBSC: false,
                  })
                }
              >
                <img src={`/static/${IDa}`} className="img" />
                <p>Por identificador</p>
              </div>
            </div>
            <div className="col-8">
              {!this.state.firstLoad ? (
                this.state.manualProvider ? (
                  <ManualProvider
                    bySearch={this.state.bySearch}
                    bscForm={true}
                    submitUrl={`/providers`}
                  />
                ) : this.state.fileProviderBSC ? (
                  <FileProviderBSC />
                ) : (
                  <SearchProvider getProviderByCif={this.getProviderByCif} />
                )
              ) : null}
            </div>
          </div>
          <CustomModal
            key={`table-modal`}
            show={modal.show}
            handleClose={() => this.closeModal()}
          >
            {modal.content}
          </CustomModal>
        </div>
      </MainTemplate>
    );
  }
}

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(ClientActions, dispatch),
  };
};

export default connect(null, mapDispatch)(NewBackOfficeProvider);
 */
